export default __webpack_public_path__ + "static/media/inventory_package.8563a20f.svg";